module.exports = __webpack_public_path__ + "static/media/hand-holding.12370445.svg";